import StateEnum from '@enums/state-enum';
import { isEmpty } from 'lodash/lang';
import { isActive, isInProgress } from '@enums/offer-state-enum';

/*
* A chat is blocked if:
* a) the enquiry is abandoned / closed
* b) the enquiry is in bidding state and there are no messages nor offers from the provider
* c) the enquiry is in an advanced state but there are no active / in progress offers
*
* @param {Object} state
* @param {Array} messages from provider
* @param {Array} offers from provider
* @return {Array} The processed object to use
*/
export default function isChatBlocked(state, messages, offers) {
  switch (state) {
    case StateEnum.CREATED:
    case StateEnum.SETTLED:
    case StateEnum.CLOSED:
      return true;
    case StateEnum.ACTIVE:
    case StateEnum.DECISION:
    case StateEnum.BIDDING: {
      if (!isEmpty(messages)) {
        return false;
      }

      return !hasAdvancedOffers(offers);
    }
    case StateEnum.CONTACT:
    case StateEnum.APPLICATION:
    case StateEnum.PENDING: {
      return !hasAdvancedOffers(offers);
    }
    default:
      return false;
  }
}

function hasAdvancedOffers(offers) {
  if (isEmpty(offers)) {
    return false;
  }

  const offersActive = offers.filter((offer) => isActive(offer));
  const offersInProgress = offers.filter((offer) => isInProgress(offer));

  return offersActive.length > 0 || offersInProgress.length > 0;
}
